var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vscroller"},[_c('div',{staticClass:"vscroller__head"},[_vm._v(_vm._s(_vm.scrollerTitle))]),_c('div',{staticClass:"vscroller__body"},[_c('ul',{ref:"ul",style:({
        webkitTransition:
          '-webkit-transForm ' + _vm.transitionDuration / 1000 + 's ease-out',
        transition: 'transForm ' + _vm.transitionDuration / 1000 + 's ease-out',
        webkitTransForm:
          'translate3d(0px, ' + _vm.currentTranslatedY + 'px, 0px)',
        transForm: 'translate3d(0px, ' + _vm.currentTranslatedY + 'px, 0px)',
      })},_vm._l((_vm.itemList),function(item){return _c('li',{key:item.id,class:item.selected ? 'vselected' : '',attrs:{"data-val":item.value},domProps:{"textContent":_vm._s(item.name)}})}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }